import installer from './defaults'
export * from '@zoryn/components'
export * from '@zoryn/constants'
export * from '@zoryn/directives'
export * from '@zoryn/hooks'
export * from './make-installer'

export const install = installer.install
export const version = installer.version
export default installer
